@if (syndicatesList?.items.length > 1 && !syndicateId) {
  <div class="content widget syndi-x-sell">
    <div class="component-header-row">
      <div class="widget-header">
        <span [innerHTML]="'widgetSyndicatesCrossSell.HEADER' | transloco"></span>
      </div>
    </div>
    <div class="x-sell-cards w-full">
      @for (syndicate of syndicatesList.items | slice:0:3; track syndicate.stringified_id) {
        <widget-syndicate-list-card [syndicate]="syndicate" [showPercentage]="false" (click)="openPoolSyndicates(syndicate.stringified_id)"></widget-syndicate-list-card>
      }
    </div>
  </div>
}